import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Benefits from './components/Benefits';
import WhoNeeds from './components/WhoNeeds';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from '../home/components/Footer';

export default function StumpGrindingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />
      <main>
        <div className="pt-20">
          <Benefits />
          <WhoNeeds />
          <FAQ />
          <CTA />
        </div>
      </main>
      <Footer />
    </div>
  );
}
